import { ERROR_ALERT, SUCCESS_ALERT } from '../constants/actionTypes';

  const initialState = {
    isLoading: false,
    errorAlert: {action: false, message: {title: '', description: ''}},
    successAlert: {action: false, message: ''},
    error: null
  };
  
  export function alertReducer(state = initialState, action) {
    const { type } = action;
    switch (type) {
      case ERROR_ALERT:
        return {
          ...state,
          isLoading: true,
          errorAlert: {},
          successAlert: false,
          error: null
        };
      
      case SUCCESS_ALERT:
        return {
          ...state,
          successAlert: {},
        };
      default:
        return state;
    }
  }
  